import React, { useEffect, useState } from "react";
import "./Footer.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSocialmedia } from "../../features/socialmedia/Slice";
import { postSubscriber } from "../../features/home/homeSlice";
import Book_appointment_modal from "../common-components/common-modals/book-appointment-modal/Book_appointment_modal";

const Footer = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [email, setEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState(null);
  const navigate = useNavigate();

  const medias = useSelector((state) => state.socialmedia.addSocialmedia);

  useEffect(() => {
    dispatch(getSocialmedia());
  }, [dispatch]);

  const SUPPORT_LINKS = [
    { label: "What's new", to: "/all-products?offers=true" },
    { label: "Bapat Benefits", to: "/bapat-benefits" },
    { label: "Bapat Academy", to: "/bapat-academy" },
    { label: "About Us", to: "/about-us" },
    { label: "Contact Us", to: "/contact-us" },
    { label: "Refer a friend", to: "/bapat-benefits" },
    { label: "Reward System", to: "/my-account" },
    { label: "Shipping Policy", to: "/shipping-policy" },
    { label: "Privacy Policy", to: "/privacy" },
  ];

  const CONTACT_LINKS = [
    { label: "Careers", to: "/careers" },
    { label: "Track Your Order", to: "/my-account" },
  ];

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await dispatch(postSubscriber({ data: { email } })).unwrap();
      setSubscribeStatus("success");
      setEmail("");
    } catch (err) {
      setSubscribeStatus("error");
    }
  };

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="content_div">
            <div className="row">
              <div className="col-lg-3 col-md-6 mb-4 p-1">
                <div className="link_div">
                  <h3 className="heading_text">Support</h3>
                  <ul className="about_ul">
                    {SUPPORT_LINKS.map((item) => (
                      <li key={item.label}>
                        <Link className="link_text heading" to={item.to}>
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4 p-1">
                <div className="link_div">
                  <h3 className="heading_text">Contact</h3>
                  <ul className="about_ul">
                    {CONTACT_LINKS.map((item) => (
                      <li key={item.label}>
                        {item.href ? (
                          <a className="link_text heading" href={item.href}>
                            {item.label}
                          </a>
                        ) : (
                          <Link className="link_text heading" to={item.to}>
                            {item.label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4 p-1">
                <div className="link_div about_shop_div">
                  <h3 className="heading_text">About The Shop</h3>
                  <p className="info_text">
                    Welcome to Bapat Optics. For over 20 years, we have
                    provided comprehensive precision eye care built on trust
                    and expertise. As a partnered ZEISS Vision Center, we
                    deliver exceptional accuracy in vision assessment and lens
                    customization. Discover our extensive collection of
                    premium eyewear, featuring trusted international brands,
                    prescription spectacles, sunglasses, and children's
                    options designed for perfect comfort and style. Bapat
                    Optics - Experience the Art of Precision Vision.
                  </p>
                  <div className="all_icons_holder">
                    {medias?.map((data, index) => {
                      const fullUrl =
                        data.url?.startsWith("http://") ||
                        data.url?.startsWith("https://")
                          ? data.url
                          : `https://${data.url}`;
                      return (
                        <a
                          key={index}
                          href={fullUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="social_icon_holder">
                            <img
                              src={process.env.REACT_APP_IMAGE_URL + data.image}
                              className="social_icon"
                              alt={data.name}
                            />
                          </div>
                        </a>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4 p-1">
                <div className="link_div join_club_div">
                  <h3 className="heading_text">Join The Club</h3>
                  <p className="info_text">
                    Subscribe to receive updates, access to exclusive deals,
                    and more.
                  </p>
                  <form className="subscribe_form" onSubmit={handleSubscribe}>
                    <input
                      type="email"
                      required
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setSubscribeStatus(null);
                      }}
                    />
                    <button type="submit" className="heading">
                      Subscribe
                    </button>
                  </form>
                  {subscribeStatus === "success" && (
                    <p className="subscribe_msg success">
                      Thanks for subscribing!
                    </p>
                  )}
                  {subscribeStatus === "error" && (
                    <p className="subscribe_msg error">
                      Something went wrong, please try again.
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="copyrightdiv">
              <p className="cppp">
                &copy; {new Date().getFullYear()} Bapat Optics. All Rights
                Reserved.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Book_appointment_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Footer;